import { capitalize } from "lodash";

const functions = {
  miToM(miles) {
    return miles * 1609.344;
  },

  mToMi(meters) {
    return meters / 1609.344;
  },

  mToFt(meters) {
    return meters * 3.28084;
  },

  mToKm(meters) {
    return meters / 1000;
  },

  mToM(meters) {
    return meters;
  },

  kmToM(kilometers) {
    return kilometers / 1000;
  },

  kmToMi(kilometers) {
    return kilometers * 1000 / 1609.344;
  }
};

function unitNameFor(units) {
  switch (units.toLowerCase()) {
    case 'meters':
    case 'meter':
    case 'm':
      return 'm';
    case 'miles':
    case 'mile':
    case 'mi':
      return 'mi';
    case 'kilometers':
    case 'kilometer':
    case 'km':
      return 'km';
    case 'feet':
    case 'ft':
      return 'ft';
  }

  throw `Unsupport unit "${units}"`;
}

function unitConversion(value, options) {
  const key = unitNameFor(options.from) + "To" + capitalize(unitNameFor(options.to));

  return functions[key](value);
}

export default unitConversion;
